module.exports = __webpack_public_path__ + "img/Sokal-Toyota-SRS-112221-Playful.b33d7515.jpeg";